import React from "react";
import style from "./index.module.less";
import { processOssImage } from "@/utils/image";
import { useServerNow } from "@/hooks/useServerTimeSync";
import { getRemainingSeconds } from "@/utils/server-time";

const CountDown: React.FC<{
  bgUrl?: string;
  endTime: string;
}> = (props) => {
  const { bgUrl, endTime } = props;

  const serverNow = useServerNow();
  const parsedEndTime = endTime ? new Date(endTime).getTime() : 0;
  const totalSeconds = parsedEndTime
    ? getRemainingSeconds(parsedEndTime, serverNow)
    : 0;
  const days = Math.floor(totalSeconds / 86400);
  const hours = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(
    2,
    "0",
  );
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
    2,
    "0",
  );
  const seconds = String(totalSeconds % 60).padStart(2, "0");

  return (
    <div className={style["countdown"]}>
      <span
        style={{
          backgroundImage: `url(${processOssImage(bgUrl)})`,
          backgroundSize: "100% 100%",
        }}
      >
        距离活动结束还剩:
        <span className={style["dateWidth"]}>
          {String(days).padStart(2, "0")}
        </span>
        天<span className={style["dateWidth"]}>{hours}</span>时
        <span className={style["dateWidth"]}>{minutes}</span>分
        <span className={style["dateWidth"]}>{seconds}</span>秒
      </span>
    </div>
  );
};

export default CountDown;
